// extracted by mini-css-extract-plugin
export default {"Scroll":"Scroll_Scroll__uQhw2","VerticalBranch":"Scroll_VerticalBranch__5kV3D","HorizontalBranch":"Scroll_HorizontalBranch__ZYu5f"};